import React from 'react';
import isEmpty from 'lodash/isEmpty';
import UI from '../../ui';

const { WrappedButton, WrappedButtonType } = UI;

const EditProductDetails = ({ showMobileView, editingInbound }) => {
	const { items = [] } = editingInbound;

	const mobileClassName = showMobileView ? 'mobile-wrapper' : '';
	return (
		<div className={`common-inbound-details-edit-product-details ${mobileClassName}`}>
			<div className="product-details-header">Product Details</div>

			<div className="product-details-content">
				<div className="p-grid p-col-12 p-dir-col product-list">
					{!showMobileView && (
						<div className="sub-header p-grid p-dir-row">
							<p className="p-lg-3">Product</p>
							<p className="p-lg-3">Barcode</p>
							<p className="p-lg-2">Qty. Expected</p>
							<p className="p-lg-2">Qty. Received</p>
							<p className="p-lg-2">Qty. Received Damaged</p>
						</div>
					)}

					<div className="p-dir-col">
						{items.length > 0 &&
							items.map((productItem, index) => (
								<div
									className={`p-grid product-item ${
										showMobileView ? 'p-dir-col' : 'p-dir-row'
									}`}
									key={index}
								>
									<div className="read-only-label-container p-lg-3">
										{showMobileView && (
											<div className="read-only-label">Product</div>
										)}
										<div className="read-only-text">
											{`${productItem.sku} (${productItem.name}) `}
										</div>
									</div>

									<div className="read-only-label-container p-lg-3">
										{showMobileView && (
											<div className="read-only-label">Barcode</div>
										)}
										<div className="read-only-text">Barcode static value</div>
									</div>

									<div className="read-only-label-container p-lg-2">
										{showMobileView && (
											<div className="read-only-label">Qty. Expected</div>
										)}
										<div className="read-only-text">
											{productItem.quantityExpected}
										</div>
									</div>

									<div className="read-only-label-container p-lg-2">
										{showMobileView && (
											<div className="read-only-label">Qty. Received</div>
										)}
										<div className="read-only-text">
											{productItem.quantityReceivedSellable}
										</div>
									</div>

									<div className="read-only-label-container p-lg-2">
										{showMobileView && (
											<div className="read-only-label ">
												Qty. Received Damaged
											</div>
										)}
										<div className="read-only-text">
											{productItem.quantityReceivedDamaged}
										</div>
									</div>
								</div>
							))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default EditProductDetails;
